import React from 'react'
import { Box, Container, Grid, useTheme } from '@material-ui/core'

import { useIsMobile } from 'utils/hooks'
import { colors } from 'theme'

import BraintreeBadge from './BraintreeBadge'
import MoneyBackGuaranteeBadge from './MoneyBackGuaranteeBadge'

const FooterTop = () => {
  const theme = useTheme()
  const isMobile = useIsMobile()

  return (
    <Box
      bgcolor={colors.darkenBlueGreen}
      alignSelf="stretch"
      css={{
        padding: theme.spacing(2, 0),
      }}
    >
      <Container
        css={{
          maxWidth: 'min(960px, calc(100% - 24px))',
          padding: theme.spacing(1),
        }}
      >
        <Grid
          container
          justify="center"
          alignItems="center"
          spacing={isMobile ? 1 : 5}
        >
          <Grid item xs={6} sm="auto" style={{ flexBasis: 0 }}>
            <MoneyBackGuaranteeBadge />
          </Grid>
          <Grid item>
            <BraintreeBadge />
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}
export default FooterTop
